import type { ContactSubmission } from '#shared/types';
import { loadRuntimeConfig } from '#src/config';

export const submitContact = async (
  submission: ContactSubmission,
): Promise<{ message: string }> => {
  const config = await loadRuntimeConfig();
  const response = await fetch(`${config.apiUrl}/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(submission),
  });

  const data = await response.json();
  if (!response.ok) {
    throw data;
  }
  return data as { message: string };
};
